var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg32IconUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_32_icon_down",
    "data-name": "32/icon/down",
    transform: "translate(0 32) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1962",
    "data-name": "Rectangle 1962",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(0 32) rotate(-90)",
    fill: "#f4f3f0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421",
    transform: "translate(-2709.547 243.688) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M0,7.7A21.508,21.508,0,0,1,3.4,2.923,15.313,15.313,0,0,1,7.8,0",
    transform: "translate(227.301 2726.529)",
    fill: "none",
    stroke: "#7d6a2d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M0,25.136V8.866",
    transform: "translate(227.301 2708.322)",
    fill: "none",
    stroke: "#7d6a2d",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M7.8,7.7A21.508,21.508,0,0,0,4.4,2.923,15.313,15.313,0,0,0,0,0",
    transform: "translate(219.5 2726.529)",
    fill: "none",
    stroke: "#7d6a2d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32IconUp);
export default __webpack_public_path__ + "static/media/32-icon-up.3c26ea9a.svg";
export { ForwardRef as ReactComponent };